import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logos/gorate-logo.svg'
import _imports_1 from '../../assets/logos/montepio-logo.webp'


const _withScopeId = (n: any) => (_pushScopeId("data-v-2ad900ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"logos-container\" data-v-2ad900ab><div class=\"gorate-logo-container\" data-v-2ad900ab><img src=\"" + _imports_0 + "\" alt=\"gorate-logo\" data-v-2ad900ab></div><div class=\"customer-logo-container\" data-v-2ad900ab><img src=\"" + _imports_1 + "\" alt=\"montepio-logo\" data-v-2ad900ab></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Dashboard') }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('Dashboard')))
    }, _toDisplayString(_ctx.$t('i18n.dashboard')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Devices') }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('Devices')))
    }, _toDisplayString(_ctx.$t('i18n.devices')), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["navbar-item", { 'active-link': _ctx.isActiveRoute('Forms') || _ctx.isActiveRoute('CreateForm') || _ctx.isActiveRoute('EditForm') }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('Forms')))
    }, _toDisplayString(_ctx.$t('i18n.forms')), 3),
    _createVNode(_component_UserAvatar)
  ]))
}